import React from "react";
import Layout from "layouts";
import StaffComponent from "./StaffComponent";

export default function Staffs() {
  return (
    <Layout breadCrumb={[{ label: "Staff Users", to: "/staff-users" }]}>
      <StaffComponent />
    </Layout>
  );
}
